
import index from './router/index'
import liveRouter from './router/live-router'
export default [
      ...index,
      ...liveRouter,

  ]